/**
 * Captures the install prompt at module load, before React mounts — Chromium
 * fires `beforeinstallprompt` early and the event is only usable if it was
 * preventDefault()ed at that moment.
 */
export let pendingInstallPrompt: BeforeInstallPromptEvent | null = null

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  pendingInstallPrompt = event as BeforeInstallPromptEvent
})

export function clearInstallPrompt() {
  pendingInstallPrompt = null
}
